/**
 * Clickable table row
 */

import { isBlank, trim } from "../../utils/commons";

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  selected?: boolean;
  children?: React.ReactNode;
  onSelect?: () => void;
}

const TableRow = (props: TableRowProps) => {
  const { selected, children, onSelect, className, ...trProps } = props;

  const classNames = selected ? ['table-primary'] : ['pe-force', 'action-link'];
  !isBlank(className) && classNames.push(trim(className))

  if (!onSelect) {
    return <tr {...trProps}>{children}</tr>;
  }

  return (
    <tr {...trProps}
      className={classNames.join(' ')}
      tabIndex={selected ? -1 : 0}
      onClick={() => onSelect?.()}
      onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect?.()}>
      {children}
    </tr>
  );
};

export default TableRow;
